import styled, { css } from 'styled-components';
import { Form } from 'react-bootstrap';

export const RequiredIndicator = styled.span`
  color: #dc3545;
  margin-left: 4px;
`;

export const CustomFieldFormGroup = styled(Form.Group)`
  border: #fff solid 2px;
  border-radius: 8px;
  padding: 12px !important;
  transition: all 0.2s ease-in-out;
  position: relative;

  /* Handle z-index for form fields */
  &:focus-within {
    z-index: 100;
  }

  /* Ensure dropdowns appear above other elements */
  .react-select__menu,
  .react-select__control {
    z-index: 999 !important;
  }

  /* Ensure proper stacking context */
  .form-control:focus,
  .custom-select:focus {
    z-index: 10;
    position: relative;
  }

  label {
    font-weight: 600;
  }

  ${({ preview }) =>
    preview &&
    css`
    &:hover {
      background-color: rgba(22, 110, 225, 0.05);
    }
  `}

  ${({ isSelected }) =>
    isSelected &&
    css`
    border-color: rgb(22, 110, 225);
    cursor: pointer;

    &:hover {
      background-color: transparent;
    }
  `}
`;

// Add a styled component for the grid container to properly handle tabbing
export const FormGridContainer = styled.div`
  .react-grid-item {
    display: flex;
    flex-direction: column;
  }
`;
